import { supabase } from './supabase'
import { adminSupabase } from './adminSupabase'
import * as Sentry from '@sentry/react'

async function invoke(name, body, options, client) {
  if (!client) {
    // Dev-only notice: the caller still throws a user-facing error below, and
    // real failures are reported via Sentry breadcrumbs — keep prod consoles clean.
    if (import.meta.env.DEV) console.warn(`[api] '${name}' invoked but the backend client is not configured`)
    throw new Error(`${name} is not available right now. The backend is not configured yet. Please try again later.`)
  }
  const { data, error } = await client.functions.invoke(name, { body, ...options })
  if (error) {
    const msg =
      error.message || error.context?.message || 'Something went wrong. Please try again.'
    if (import.meta.env.PROD) {
      Sentry.addBreadcrumb({
        category: 'api',
        level: 'error',
        message: `${name} failed`,
        data: { function: name, detail: msg },
      })
    }
    throw new Error(msg)
  }
  if (import.meta.env.PROD) {
    Sentry.addBreadcrumb({ category: 'api', level: 'info', message: `${name} ok` })
  }
  return data
}

// End-user scope. Auth is the shared user session (`./supabase`).
export async function api(name, body = {}, options = {}) {
  return invoke(name, body, options, supabase)
}

// Admin-console scope. Auth is the dedicated admin session (`./adminSupabase`)
// so admin-facing edge calls carry the admin-console session's JWT, keeping the
// two surfaces fully independent.
export async function adminApi(name, body = {}, options = {}) {
  return invoke(name, body, options, adminSupabase)
}